import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

//libs
import { timezone } from '@/lib/settings/optionsConfiguration/platformSettings/timezone';

//components
import { SelectFilterComponent } from '@/components/base/SelectFilter/SelectFilterComponent';

export function PlatformTimezone() {
    const { t } = useTranslation('settings');

    const options = timezone;

    const {
        control,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <Controller
            key={'timezone'}
            control={control}
            name={'timezone'}
            render={({ field: { onChange, value } }) => {
                return (
                    <SelectFilterComponent
                        idInput={'search_timezone'}
                        selected={options?.find((item) => value['value'] === item.value)}
                        setSelected={onChange}
                        label={t('platform_page.timezone')}
                        error={errors.timezone?.message}
                        options={options}
                    />
                );
            }}
        />
    );
}
